export const LogoIcon = () => {
  return (
    <svg
      className="h-[22.87px] w-[20.24px] 2xl:h-[47px] 2xl:w-[41px]"
      viewBox="0 0 41 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.19"
        d="M40.4805 11.5243C40.3476 11.2868 40.148 11.0937 39.9063 10.9687L21.4339 1.92772C21.2679 1.85422 21.0883 1.81616 20.9068 1.81616C20.7252 1.81616 20.5456 1.85422 20.3796 1.92772L1.90832 10.9687C1.66671 11.0926 1.46666 11.2846 1.33301 11.521C1.19016 11.7693 1.1147 12.0506 1.11426 12.3369V18.5549C1.12301 24.5815 2.83254 30.4473 5.99566 35.3046C8.27941 38.7663 11.2457 41.586 14.6505 43.546L18.635 45.8068C19.3215 46.2155 20.1056 46.4313 20.9046 46.4313C21.7036 46.4313 22.4877 46.2155 23.1741 45.8068L27.1586 43.546C30.5678 41.586 33.5297 38.7663 35.8135 35.3046C38.9766 30.4473 40.6861 24.5858 40.6949 18.5549V12.3402C40.6958 12.0542 40.6218 11.7729 40.4805 11.5243ZM28.166 18.4587C28.0089 19.8162 27.4734 21.1021 26.6205 22.1699C25.7676 23.2377 24.6317 24.0441 23.3425 24.4973V35.5233C23.33 35.7162 23.2425 35.8963 23.0986 36.0254L21.4755 37.6441C21.402 37.7209 21.3137 37.7819 21.216 37.8237C21.1182 37.8654 21.0131 37.8869 20.9068 37.8869C20.8004 37.8869 20.6953 37.8654 20.5976 37.8237C20.4998 37.7819 20.4115 37.7209 20.338 37.6441L18.7149 36.0254C18.6368 35.9534 18.5747 35.8657 18.5326 35.7681C18.4906 35.6705 18.4696 35.5651 18.471 35.4588V24.4973C17.2479 24.0585 16.1646 23.3006 15.3333 22.302C14.5021 21.3034 13.9531 20.1006 13.7436 18.8183C13.5339 17.536 13.6713 16.221 14.1414 15.0096C14.6115 13.7983 15.3971 12.7348 16.4167 11.9296C17.4364 11.1243 18.6531 10.6066 19.9403 10.4301C21.2276 10.2537 22.5386 10.4248 23.7375 10.926C24.9362 11.427 25.9791 12.2398 26.7578 13.28C27.5365 14.3201 28.0227 15.5496 28.166 16.841C28.2064 17.1088 28.2225 17.3797 28.2141 17.6504C28.2221 17.9208 28.2059 18.1912 28.166 18.4587ZM20.9068 15.2201C20.4614 15.2198 20.0244 15.3421 19.6438 15.5735C19.2632 15.8048 18.9535 16.1364 18.7486 16.5319C18.5437 16.9274 18.4515 17.3716 18.482 17.816C18.5126 18.2604 18.6648 18.6878 18.9219 19.0515C19.179 19.4153 19.5311 19.7013 19.9399 19.8783C20.3486 20.0554 20.7981 20.1167 21.2393 20.0555C21.6805 19.9943 22.0963 19.8129 22.4415 19.5313C22.7866 19.2498 23.0476 18.8787 23.196 18.4587C23.3914 17.9368 23.3914 17.3618 23.196 16.8399C23.0291 16.3661 22.7192 15.9558 22.3092 15.6657C21.8991 15.3756 21.4091 15.2198 20.9068 15.2201Z"
        fill="#222222"
      />
      <path
        d="M39.5781 10.399C39.4436 10.1646 39.2437 9.97467 39.0028 9.85217L20.5272 0.802479C20.3612 0.728979 20.1816 0.690918 20 0.690918C19.8185 0.690918 19.6389 0.728979 19.4728 0.802479L1.00158 9.8467C0.760739 9.9692 0.560801 10.1592 0.42627 10.3936C0.283426 10.6419 0.207957 10.9231 0.20752 11.2095V17.4329C0.21627 23.4595 1.9258 29.3253 5.08893 34.1826C7.37268 37.6444 10.3389 40.464 13.7438 42.424L17.7283 44.6848C18.4147 45.0936 19.1988 45.3094 19.9978 45.3094C20.7968 45.3094 21.5809 45.0936 22.2674 44.6848L26.2519 42.424C29.6611 40.464 32.623 37.6444 34.9067 34.1826C38.0699 29.3253 39.7794 23.4639 39.7881 17.4329V11.215C39.7903 10.9294 39.718 10.6481 39.5781 10.399ZM27.2636 17.3334C27.1066 18.6909 26.5711 19.9769 25.7181 21.0446C24.8652 22.1124 23.7294 22.9189 22.4402 23.372V34.3981C22.4253 34.5922 22.3345 34.7726 22.1875 34.9001L20.5688 36.5189C20.4953 36.5957 20.407 36.6567 20.3092 36.6985C20.2114 36.7402 20.1063 36.7617 20 36.7617C19.8937 36.7617 19.7886 36.7402 19.6908 36.6985C19.593 36.6567 19.5048 36.5957 19.4313 36.5189L17.8125 34.9001C17.7343 34.8282 17.6723 34.7404 17.6302 34.6429C17.5882 34.5452 17.5672 34.4399 17.5686 34.3336V23.372C16.3456 22.9333 15.2622 22.1753 14.431 21.1767C13.5997 20.1782 13.0508 18.9754 12.8412 17.693C12.6315 16.4107 12.7689 15.0957 13.239 13.8844C13.7091 12.6731 14.4947 11.6096 15.5143 10.8043C16.534 9.99906 17.7507 9.48128 19.038 9.30485C20.3252 9.12832 21.6363 9.29961 22.8351 9.80065C24.0339 10.3018 25.0768 11.1146 25.8554 12.1547C26.6342 13.1948 27.1203 14.4244 27.2636 15.7158C27.3041 15.9835 27.3202 16.2544 27.3117 16.5251C27.3182 16.7956 27.3007 17.0661 27.2592 17.3334H27.2636ZM20 14.0948C19.5546 14.0946 19.1177 14.2169 18.7371 14.4482C18.3564 14.6795 18.0468 15.0112 17.8418 15.4067C17.637 15.8022 17.5448 16.2463 17.5753 16.6907C17.6059 17.1351 17.7581 17.5624 18.0152 17.9262C18.2722 18.29 18.6244 18.576 19.0331 18.7531C19.4419 18.9302 19.8914 18.9914 20.3325 18.9303C20.7737 18.869 21.1896 18.6877 21.5348 18.4061C21.8799 18.1245 22.1408 17.7534 22.2892 17.3334C22.4847 16.8116 22.4847 16.2366 22.2892 15.7147C22.1223 15.2409 21.8125 14.8306 21.4024 14.5404C20.9924 14.2504 20.5024 14.0946 20 14.0948Z"
        fill="#5072F1"
      />
    </svg>
  );
};

export const UserIcon = () => {
  return (
    <svg
      className="h-[36px] w-[36px] md:h-[38px] md:w-[38px] 2xl:h-[73px] 2xl:w-[73px]"
      viewBox="0 0 73 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.166687"
        y="0.5"
        width="72"
        height="72"
        rx="36"
        fill="#5072F1"
        fillOpacity="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.1654 34.4987C37.7567 34.4987 39.2829 33.8666 40.4082 32.7413C41.5334 31.6161 42.1656 30.0899 42.1656 28.4985C42.1656 26.9072 41.5334 25.381 40.4082 24.2557C39.2829 23.1305 37.7567 22.4983 36.1654 22.4983C34.574 22.4983 33.0478 23.1305 31.9226 24.2557C30.7973 25.381 30.1652 26.9072 30.1652 28.4985C30.1652 30.0899 30.7973 31.6161 31.9226 32.7413C33.0478 33.8666 34.574 34.4987 36.1654 34.4987ZM27.6628 52.4994C24.6264 52.4994 22.0686 49.9469 23.2306 47.1416C23.9342 45.443 24.9654 43.8996 26.2655 42.5995C27.5656 41.2995 29.109 40.2682 30.8076 39.5646C32.5062 38.861 34.3268 38.4989 36.1654 38.4989C38.004 38.4989 39.8245 38.861 41.5231 39.5646C43.2218 40.2682 44.7652 41.2995 46.0652 42.5995C47.3653 43.8996 48.3966 45.443 49.1002 47.1416C50.2622 49.9469 47.7044 52.4994 44.6679 52.4994H27.6628Z"
        fill="#5072F1"
      />
    </svg>
  );
};

export const LocationIcon = () => {
  return (
    <svg
      className="h-[36px] w-[36px] md:h-[38px] md:w-[38px] 2xl:h-[73px] 2xl:w-[72px]"
      viewBox="0 0 72 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3.05176e-05"
        y="0.5"
        width="72"
        height="72"
        rx="36"
        fill="#5072F1"
        fillOpacity="0.1"
      />
      <path
        d="M47.6667 31.4999C47.6667 29.9678 47.3649 28.4507 46.7786 27.0353C46.1923 25.6198 45.333 24.3337 44.2496 23.2503C43.1663 22.167 41.8801 21.3076 40.4647 20.7213C39.0492 20.135 37.5321 19.8333 36 19.8333C34.468 19.8333 32.9509 20.135 31.5354 20.7213C30.1199 21.3076 28.8338 22.167 27.7505 23.2503C26.6671 24.3337 25.8078 25.6198 25.2214 27.0353C24.6351 28.4507 24.3334 29.9678 24.3334 31.4999C24.3334 33.8116 25.0167 35.9616 26.175 37.7749H26.1617C30.095 43.9333 36 53.1666 36 53.1666L45.8384 37.7749H45.8267C47.0274 35.9022 47.666 33.7245 47.6667 31.4999ZM36 36.4999C34.674 36.4999 33.4022 35.9731 32.4645 35.0355C31.5268 34.0978 31 32.826 31 31.4999C31 30.1738 31.5268 28.9021 32.4645 27.9644C33.4022 27.0267 34.674 26.4999 36 26.4999C37.3261 26.4999 38.5979 27.0267 39.5356 27.9644C40.4733 28.9021 41 30.1738 41 31.4999C41 32.826 40.4733 34.0978 39.5356 35.0355C38.5979 35.9731 37.3261 36.4999 36 36.4999Z"
        fill="#5072F1"
      />
    </svg>
  );
};

export const ServerIcon = () => {
  return (
    <svg
      className="h-[36px] w-[36px] md:h-[38px] md:w-[38px] 2xl:h-[73px] 2xl:w-[73px]"
      viewBox="0 0 73 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.333374"
        y="0.5"
        width="72"
        height="72"
        rx="36"
        fill="#5072F1"
        fillOpacity="0.1"
      />
      <path
        d="M49.6667 21.5H23C22.116 21.5 21.2681 21.8512 20.643 22.4763C20.0179 23.1014 19.6667 23.9493 19.6667 24.8333V31.5C19.6667 32.3841 20.0179 33.2319 20.643 33.857C21.2681 34.4821 22.116 34.8333 23 34.8333H49.6667C50.5507 34.8333 51.3986 34.4821 52.0237 33.857C52.6488 33.2319 53 32.3841 53 31.5V24.8333C53 23.9493 52.6488 23.1014 52.0237 22.4763C51.3986 21.8512 50.5507 21.5 49.6667 21.5ZM41.3334 28.1667C41.3334 29.0871 40.5872 29.8333 39.6667 29.8333C38.7462 29.8333 38 29.0871 38 28.1667C38 27.2462 38.7462 26.5 39.6667 26.5C40.5872 26.5 41.3334 27.2462 41.3334 28.1667ZM48 28.1667C48 29.0871 47.2538 29.8333 46.3334 29.8333C45.4129 29.8333 44.6667 29.0871 44.6667 28.1667C44.6667 27.2462 45.4129 26.5 46.3334 26.5C47.2538 26.5 48 27.2462 48 28.1667ZM49.6667 38.1667H23C22.116 38.1667 21.2681 38.5179 20.643 39.143C20.0179 39.7681 19.6667 40.6159 19.6667 41.5V48.1667C19.6667 49.0507 20.0179 49.8986 20.643 50.5237C21.2681 51.1488 22.116 51.5 23 51.5H49.6667C50.5507 51.5 51.3986 51.1488 52.0237 50.5237C52.6488 49.8986 53 49.0507 53 48.1667V41.5C53 40.6159 52.6488 39.7681 52.0237 39.143C51.3986 38.5179 50.5507 38.1667 49.6667 38.1667ZM41.3334 44.8333C41.3334 45.7538 40.5872 46.5 39.6667 46.5C38.7462 46.5 38 45.7538 38 44.8333C38 43.9129 38.7462 43.1667 39.6667 43.1667C40.5872 43.1667 41.3334 43.9129 41.3334 44.8333ZM48 44.8333C48 45.7538 47.2538 46.5 46.3334 46.5C45.4129 46.5 44.6667 45.7538 44.6667 44.8333C44.6667 43.9129 45.4129 43.1667 46.3334 43.1667C47.2538 43.1667 48 43.9129 48 44.8333Z"
        fill="#5072F1"
      />
    </svg>
  );
};

export const LogsIcon = () => {
  return (
    <svg
      className="h-[36px] w-[36px] md:h-[48px] md:w-[48px] 2xl:h-[56px] 2xl:w-[56px]"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.946 54.7556H70.1954C71.5389 54.7556 72.8034 55.2806 73.6445 56.1895L79.3291 62.3087C79.888 62.9128 80.7347 63.2627 81.6323 63.2627H144.468C146.692 63.2627 148.498 64.8264 148.498 66.7571V143.033C148.498 147.199 144.603 150.575 139.805 150.575H31.933C28.5686 150.575 25.8477 148.21 25.8477 145.291V58.3177C25.8477 56.3532 27.6823 54.7556 29.9516 54.7556H29.946Z"
        fill="#9FC9D3"
      />
      <path
        d="M59.4587 9.19995L42.5234 26.1352V91.031H125.54V9.19995H59.4587Z"
        fill="#E8385F"
      />
      <path
        d="M59.4587 26.1352V9.19995L42.5234 26.1352H59.4587Z"
        fill="#9F3049"
      />
      <path
        d="M15.8275 73.8755H127.363C129.993 73.8755 132.246 75.5013 132.731 77.7424L147.284 144.97C147.917 147.888 145.337 150.586 141.916 150.586H30.3805C27.7499 150.586 25.4975 148.961 25.012 146.72L10.459 79.4923C9.82676 76.5738 12.4066 73.8755 15.8275 73.8755Z"
        fill="#3F5C6C"
      />
      <path
        d="M87.4187 43.9565C89.5413 41.8057 91.6581 39.6493 93.7807 37.4929C95.0283 36.2228 95.1412 33.9365 93.7807 32.689C92.4315 31.4527 90.309 31.3341 88.9767 32.689C86.826 34.8002 84.6752 36.9171 82.5301 39.034C80.4075 36.9115 78.2737 34.7946 76.1173 32.7002C74.8641 31.4075 72.4988 31.3454 71.2568 32.7002C69.9811 34.0889 69.919 36.1833 71.2568 37.5607C73.3455 39.7114 75.4511 41.8396 77.5737 43.9565C75.4568 46.0734 73.3455 48.196 71.2625 50.3468C69.9698 51.6 69.9077 53.9652 71.2625 55.2072C72.6512 56.4829 74.7455 56.545 76.1229 55.2072C78.2793 53.1185 80.4075 51.0016 82.5301 48.879C84.6752 50.9959 86.8203 53.1072 88.9711 55.2185C90.2412 56.466 92.5275 56.5789 93.7751 55.2185C95.0113 53.8693 95.1299 51.7467 93.7751 50.4145C91.6582 48.2581 89.5413 46.1073 87.4187 43.9565Z"
        fill="#FFDA2D"
      />
    </svg>
  );
};

export const PrivacyIcon = () => {
  return (
    <svg
      className="h-[36px] w-[36px] md:h-[48px] md:w-[48px] 2xl:h-[56px] 2xl:w-[56px]"
      viewBox="0 0 161 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6666 69.4419C15.6666 46.0992 15.6666 34.428 18.3722 30.5016C21.0777 26.5751 31.8513 22.8187 53.3985 15.3058L57.5036 13.8745C68.7358 9.95815 74.3516 8 80.1666 8C85.9817 8 91.5975 9.95815 102.83 13.8745L106.935 15.3058C128.482 22.8187 139.256 26.5751 141.961 30.5016C144.667 34.428 144.667 46.0992 144.667 69.4419C144.667 72.9671 144.667 76.7908 144.667 80.9372C144.667 122.095 114.287 142.068 95.2267 150.549C90.0566 152.85 87.4716 154 80.1666 154C72.8616 154 70.2766 152.85 65.1063 150.549C46.0458 142.068 15.6666 122.095 15.6666 80.9372C15.6666 76.7908 15.6666 72.9671 15.6666 69.4419Z"
        fill="#9FC9D3"
      />
      <path
        d="M26.6666 71.5002C26.6666 52.3144 26.6666 42.7217 28.9108 39.4945C31.1549 36.2672 40.0911 33.1798 57.9636 27.0047L61.3686 25.8283C70.6852 22.6094 75.3433 21 80.1666 21C84.9899 21 89.648 22.6094 98.9647 25.8283L102.37 27.0047C120.242 33.1798 129.179 36.2672 131.423 39.4945C133.667 42.7217 133.667 52.3144 133.667 71.5002C133.667 74.3976 133.667 77.5404 133.667 80.9484C133.667 114.776 108.468 131.193 92.6583 138.164C88.37 140.054 86.2258 141 80.1666 141C74.1075 141 71.9633 140.054 67.6747 138.164C51.8649 131.193 26.6666 114.776 26.6666 80.9484C26.6666 77.5404 26.6666 74.3976 26.6666 71.5002Z"
        fill="#3F5C6C"
      />
      <path
        d="M80.6728 90.0213L98.7617 71.8449C100.777 69.8227 100.777 66.5408 98.7617 64.5167C96.7468 62.4944 93.4824 62.4944 91.4675 64.5167L80.6728 75.3643L75.1735 80.8895L69.8782 75.5693C67.8633 73.5449 64.599 73.5449 62.5841 75.5693C60.5692 77.5913 60.5692 80.8734 62.5841 82.8977L71.5264 91.8822C72.4937 92.8542 73.805 93.4 75.1735 93.4C76.5421 93.4 77.8531 92.8542 78.8206 91.8822L80.6728 90.0213Z"
        fill="#FFDA2D"
      />
    </svg>
  );
};

export const SmartLocationIcon = () => {
  return (
    <svg
      className="h-[36px] w-[36px] md:h-[48px] md:w-[48px] 2xl:h-[56px] 2xl:w-[56px]"
      viewBox="0 0 161 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_26_163)">
        <path
          d="M80.3333 148C117.889 148 148.333 137.801 148.333 125.22C148.333 112.639 117.889 102.44 80.3333 102.44C42.7779 102.44 12.3333 112.639 12.3333 125.22C12.3333 137.801 42.7779 148 80.3333 148Z"
          fill="#9FC9D3"
        />
        <path
          d="M104.111 125.22C104.111 129.619 93.4644 133.189 80.3319 133.189C67.1994 133.189 56.5532 129.619 56.5532 125.22C56.5532 120.821 67.1994 117.251 80.3319 117.251C93.4644 117.272 104.111 120.821 104.111 125.22Z"
          fill="#E8385F"
        />
        <path
          d="M122.09 53.7562C122.09 76.8125 80.3333 125.22 80.3333 125.22C80.3333 125.22 38.577 76.8125 38.577 53.7562C38.577 30.7 57.277 12 80.3333 12C103.39 12 122.09 30.7 122.09 53.7562Z"
          fill="#3F5C6C"
        />
        <path
          d="M94.7235 66.8864C101.96 58.9394 101.384 46.6309 93.4366 39.3947C85.4896 32.1584 73.1812 32.7345 65.9449 40.6815C58.7086 48.6285 59.2848 60.937 67.2318 68.1732C75.1787 75.4095 87.4872 74.8334 94.7235 66.8864Z"
          fill="#FFDA2D"
        />
      </g>
      <defs>
        <clipPath id="clip0_26_163">
          <rect
            width="136"
            height="136"
            fill="white"
            transform="translate(12.3333 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const VpnSpeedIcon = () => {
  return (
    <svg
      className="h-[36px] w-[36px] md:h-[48px] md:w-[48px] 2xl:h-[56px] 2xl:w-[56px]"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M79.9998 150C118.66 150 150 118.66 150 79.9998C150 41.34 118.66 10 79.9998 10C41.34 10 10 41.34 10 79.9998C10 118.66 41.34 150 79.9998 150Z"
        fill="#3F5C6C"
      />
      <path
        d="M61.4907 84.2506H70.8224V108.165C70.8224 111.686 74.8088 113.347 76.9228 110.69L99.7841 82.1248C101.777 79.6337 100.177 75.7476 97.1567 75.7476H87.825V51.8328C87.825 48.3121 83.8386 46.6513 81.7246 49.3085L58.8633 77.8733C56.9004 80.3644 58.5009 84.2506 61.4907 84.2506Z"
        fill="#FFDA2D"
      />
    </svg>
  );
};

export const SplitTunnelingIcon = () => {
  return (
    <svg
      className="h-[36px] w-[36px] md:h-[48px] md:w-[48px] 2xl:h-[56px] 2xl:w-[56px]"
      viewBox="0 0 161 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_26_183)">
        <path
          d="M122.375 95.1667L95.8333 57.25"
          stroke="#F2CB35"
          strokeWidth="9.375"
          strokeLinecap="square"
        />
        <path
          d="M38.9583 95.1667L65.5 57.25"
          stroke="#F2CB35"
          strokeWidth="9.375"
          strokeLinecap="square"
        />
        <path
          d="M31.6666 138C18.4118 138 7.66663 127.255 7.66663 114C7.66663 100.745 18.4118 90 31.6666 90C44.9214 90 55.6666 100.745 55.6666 114C55.6666 127.255 44.9214 138 31.6666 138Z"
          fill="#3F5C6C"
        />
        <path
          d="M129.667 138C116.412 138 105.667 127.255 105.667 114C105.667 100.745 116.412 90 129.667 90C142.921 90 153.667 100.745 153.667 114C153.667 127.255 142.921 138 129.667 138Z"
          fill="#3F5C6C"
        />
        <path
          d="M80.6666 62C67.4118 62 56.6666 51.2547 56.6666 38C56.6666 24.7453 67.4118 14 80.6666 14C93.9214 14 104.667 24.7453 104.667 38C104.667 51.2547 93.9214 62 80.6666 62Z"
          fill="#3F5C6C"
        />
      </g>
      <defs>
        <clipPath id="clip0_26_183">
          <rect
            width="160"
            height="160"
            fill="white"
            transform="translate(0.666626)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ConnectionIcon = () => {
  return (
    <svg
      className="h-[36px] w-[36px] md:h-[48px] md:w-[48px] 2xl:h-[56px] 2xl:w-[56px]"
      viewBox="0 0 161 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_26_194)">
        <path
          d="M133.492 107.84C129.265 104.274 125.868 99.8271 123.539 94.8106C121.211 89.7941 120.007 84.3293 120.011 78.7987V63C120.011 43.059 105.198 26.552 86.0111 23.7867V17.6667C86.0111 16.1638 85.414 14.7224 84.3513 13.6597C83.2886 12.597 81.8473 12 80.3444 12C78.8415 12 77.4002 12.597 76.3375 13.6597C75.2747 14.7224 74.6777 16.1638 74.6777 17.6667V23.7867C55.4847 26.552 40.6777 43.059 40.6777 63V78.7987C40.6799 84.3405 39.4698 89.8157 37.1322 94.8404C34.7945 99.8651 31.3861 104.318 27.1457 107.886C25.6132 109.207 24.5209 110.964 24.0151 112.924C23.5093 114.883 23.6142 116.949 24.3156 118.847C25.017 120.745 26.2816 122.383 27.9399 123.542C29.5982 124.702 31.5711 125.326 33.5944 125.333H127.094C132.563 125.333 137.011 120.885 137.011 115.417C137.011 112.515 135.747 109.773 133.492 107.84Z"
          fill="#3F5C6C"
        />
        <path
          d="M23.6777 73.6647C22.1748 73.6647 20.7335 73.0676 19.6708 72.0049C18.6081 70.9422 18.011 69.5009 18.011 67.998C18.011 49.077 25.3777 31.2893 38.7567 17.9103C39.8193 16.8478 41.2604 16.2509 42.7631 16.2509C44.2657 16.2509 45.7068 16.8478 46.7694 17.9103C47.8319 18.9729 48.4289 20.414 48.4289 21.9167C48.4289 23.4193 47.8319 24.8605 46.7694 25.923C41.2273 31.4358 36.8336 37.993 33.8426 45.2152C30.8516 52.4374 29.3227 60.181 29.3444 67.998C29.3444 69.5009 28.7474 70.9422 27.6847 72.0049C26.6219 73.0676 25.1806 73.6647 23.6777 73.6647Z"
          fill="#F0C419"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M93.777 143.202C89.9846 146.299 85.2405 147.993 80.3444 148C75.4483 147.993 70.7042 146.299 66.9118 143.202C63.1193 140.105 60.5105 135.796 59.5251 131H101.164C100.178 135.796 97.5694 140.105 93.777 143.202Z"
          fill="#E8385F"
        />
        <path
          d="M137.011 73.6647C135.508 73.6647 134.067 73.0676 133.004 72.0049C131.941 70.9422 131.344 69.5009 131.344 67.998C131.344 52.103 125.156 37.1657 113.919 25.923C112.857 24.8605 112.26 23.4193 112.26 21.9167C112.26 20.414 112.857 18.9729 113.919 17.9103C114.982 16.8478 116.423 16.2509 117.926 16.2509C119.428 16.2509 120.87 16.8478 121.932 17.9103C128.53 24.4727 133.761 32.2785 137.322 40.8761C140.883 49.4737 142.703 58.6922 142.678 67.998C142.678 69.5009 142.081 70.9422 141.018 72.0049C139.955 73.0676 138.514 73.6647 137.011 73.6647Z"
          fill="#F0C419"
        />
      </g>
      <defs>
        <clipPath id="clip0_26_194">
          <rect
            width="136"
            height="136"
            fill="white"
            transform="translate(12.3333 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const UnmatchPrivacyProtectionIcon = () => {
  return (
    <svg
      className="h-[32px] w-[32px] md:h-[40px] md:w-[40px] 2xl:h-[44px] 2xl:w-[44px]"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6675 43.1374C11.6675 29.281 11.6675 22.3529 13.2754 20.0221C14.8833 17.6914 21.2862 15.4615 34.0921 11.0018L36.5318 10.1522C43.2073 7.82741 46.5448 6.66504 50.0008 6.66504C53.4568 6.66504 56.7943 7.82741 63.4699 10.1522L65.9096 11.0018C78.7155 15.4615 85.1184 17.6914 86.7263 20.0221C88.3341 22.3529 88.3341 29.281 88.3341 43.1374C88.3341 45.23 88.3341 47.4998 88.3341 49.9611C88.3341 74.3924 70.2791 86.2489 58.9512 91.2833C55.8786 92.6488 54.3423 93.3317 50.0008 93.3317C45.6594 93.3317 44.123 92.6488 41.0502 91.2833C29.7223 86.2489 11.6675 74.3924 11.6675 49.9611C11.6675 47.4998 11.6675 45.23 11.6675 43.1374Z"
        stroke="#333333"
        strokeWidth="6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.0316 49.2973C54.5187 49.2973 58.1566 53.0286 58.1566 57.6306C58.1566 62.2331 54.5187 65.964 50.0316 65.964C45.5441 65.964 41.9065 62.2331 41.9065 57.6306C41.9065 53.0286 45.5441 49.2973 50.0316 49.2973Z"
        stroke="#333333"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.462 40.9623C41.9421 31.7311 58.0836 31.7311 69.5636 40.9623"
        stroke="#333333"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const GlobalContentIcon = () => {
  return (
    <svg
      className="h-[32px] w-[32px] md:h-[40px] md:w-[40px] 2xl:h-[44px] 2xl:w-[44px]"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M81.2481 25L75.1368 29.5833C73.6943 30.6652 71.9402 31.25 70.1368 31.25H56.1439C53.6543 31.25 51.3781 32.6567 50.2648 34.8836C48.8906 37.6317 49.6035 40.965 51.9814 42.9108L60.3148 49.7288C66.8727 55.0946 70.2664 63.4167 69.331 71.8383L69.2477 72.5858C68.916 75.5704 68.1827 78.4967 67.0677 81.2846L64.5814 87.5"
        stroke="#333333"
        strokeWidth="6"
      />
      <path
        d="M10.4297 43.7519L23.9218 41.5032C29.5619 40.5632 34.4517 45.4531 33.5117 51.0931L32.9512 54.456C31.9478 60.4769 34.9884 66.4481 40.4479 69.1777C44.8193 71.3635 47.0864 76.2923 45.9009 81.0335L43.763 89.5852"
        stroke="#333333"
        strokeWidth="6"
      />
      <path
        d="M50.013 89.5817C71.8743 89.5817 89.5964 71.8596 89.5964 49.9984C89.5964 28.1371 71.8743 10.415 50.013 10.415C28.1517 10.415 10.4297 28.1371 10.4297 49.9984C10.4297 71.8596 28.1517 89.5817 50.013 89.5817Z"
        stroke="#333333"
        strokeWidth="6"
      />
    </svg>
  );
};

export const BlazingFastSpeedsIcon = () => {
  return (
    <svg
      className="h-[32px] w-[32px] md:h-[40px] md:w-[40px] 2xl:h-[44px] 2xl:w-[44px]"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.8634 55.3144H53.528V85.2077C53.528 89.6087 58.511 91.6846 61.1535 88.3632L89.7302 52.6572C92.2217 49.5434 90.2209 44.6857 86.4459 44.6857H74.7812V14.7923C74.7812 10.3913 69.7982 8.31537 67.1557 11.6369L38.5792 47.3429C36.1254 50.4568 38.1262 55.3144 41.8634 55.3144Z"
        stroke="#333333"
        strokeWidth="6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.3464 16.665H9.17969"
        stroke="#333333"
        strokeWidth="6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.1797 83.1592H9.17969"
        stroke="#333333"
        strokeWidth="6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.6797 49.8242H9.17969"
        stroke="#333333"
        strokeWidth="6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const StayAnonymousOnlineIcon = () => {
  return (
    <svg
      className="h-[32px] w-[32px] md:h-[40px] md:w-[40px] 2xl:h-[44px] 2xl:w-[44px]"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M73.2044 83.5214C80.5275 83.5214 86.4641 77.5848 86.4641 70.2617C86.4641 62.9386 80.5275 57.0021 73.2044 57.0021C65.8813 57.0021 59.9448 62.9386 59.9448 70.2617C59.9448 77.5848 65.8813 83.5214 73.2044 83.5214Z"
        stroke="#333333"
        strokeWidth="6"
        strokeLinecap="round"
      />
      <path
        d="M27.487 84C34.8101 84 40.7466 78.0635 40.7466 70.7404C40.7466 63.4173 34.8101 57.4807 27.487 57.4807C20.1639 57.4807 14.2274 63.4173 14.2274 70.7404C14.2274 78.0635 20.1639 84 27.487 84Z"
        stroke="#333333"
        strokeWidth="6"
        strokeLinecap="round"
      />
      <path
        d="M6.01984 44.097H93.9802"
        stroke="#333333"
        strokeWidth="6"
        strokeLinecap="round"
      />
      <path
        d="M77.5652 44.097H19.9885L38.3358 16H61.8415L77.5652 44.097Z"
        stroke="#333333"
        strokeWidth="6"
        strokeLinecap="round"
      />
      <path
        d="M40.5339 70.7402L42.2003 69.9956C44.7262 68.8526 47.4668 68.2614 50.2394 68.2614C53.0119 68.2614 55.7525 68.8526 58.2785 69.9956L59.9448 70.7402"
        stroke="#333333"
        strokeWidth="6"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const EasyToUseIcon = () => {
  return (
    <svg
      className="h-[32px] w-[32px] md:h-[40px] md:w-[40px] 2xl:h-[44px] 2xl:w-[44px]"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.3335 43.7962C32.3335 41.807 33.0451 39.8833 34.3397 38.373L54.3018 15.0838C56.0835 13.0051 59.0514 12.4058 61.5002 13.6302C63.891 14.8256 65.039 17.5971 64.1937 20.133L57.3335 40.7135H76.5151C77.015 40.7135 77.5139 40.7585 78.0058 40.8479C82.5339 41.6712 85.5373 46.0094 84.714 50.5376L79.4109 79.7042C78.6905 83.6667 75.2394 86.5469 71.212 86.5469H40.6668C36.0645 86.5469 32.3335 82.8159 32.3335 78.2135V43.7962Z"
        stroke="#333333"
        strokeWidth="6"
        strokeLinecap="square"
      />
      <path
        d="M15.6665 82.3799V44.8799"
        stroke="#333333"
        strokeWidth="6"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const CustomerSupportIcon = () => {
  return (
    <svg
      className="h-[32px] w-[32px] md:h-[40px] md:w-[40px] 2xl:h-[44px] 2xl:w-[44px]"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6675 43.1374C11.6675 29.281 11.6675 22.3529 13.2754 20.0221C14.8833 17.6914 21.2862 15.4615 34.0921 11.0018L36.5318 10.1522C43.2073 7.82741 46.5448 6.66504 50.0008 6.66504C53.4568 6.66504 56.7943 7.82741 63.4699 10.1522L65.9096 11.0018C78.7155 15.4615 85.1184 17.6914 86.7263 20.0221C88.3341 22.3529 88.3341 29.281 88.3341 43.1374C88.3341 45.23 88.3341 47.4998 88.3341 49.9611C88.3341 74.3924 70.2791 86.2489 58.9512 91.2833C55.8786 92.6488 54.3423 93.3317 50.0008 93.3317C45.6594 93.3317 44.123 92.6488 41.0502 91.2833C29.7223 86.2489 11.6675 74.3924 11.6675 49.9611C11.6675 47.4998 11.6675 45.23 11.6675 43.1374Z"
        stroke="#333333"
        strokeWidth="6"
      />
      <path
        d="M47.1143 35.4883V52.8991H64.525"
        stroke="#333333"
        strokeWidth="6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReviewStars = () => {
  return (
    <svg
      className="h-[18px] w-[109px] md:h-[16px] md:w-[97.07px] 2xl:h-[30px] 2xl:w-[182px]"
      width="182"
      height="30"
      viewBox="0 0 182 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.588 0.384632L19.8686 9.48172L29.4375 10.9409C29.6853 10.9794 29.8907 11.1612 29.9679 11.4103C30.0451 11.6594 29.9806 11.9327 29.8015 12.1157L22.8787 19.1952L24.5132 29.1937C24.5561 29.4515 24.4552 29.7125 24.2528 29.8665C24.0504 30.0206 23.7818 30.041 23.5603 29.9191L15.001 25.1995L6.4417 29.9205C6.22028 30.0428 5.95156 30.0228 5.74905 29.8687C5.54654 29.7147 5.44557 29.4536 5.48878 29.1957L7.12328 19.1952L0.198505 12.1157C0.0194059 11.9327 -0.045065 11.6594 0.0320965 11.4103C0.109258 11.1612 0.314732 10.9794 0.562452 10.9409L10.1314 9.48172L14.414 0.384632C14.5229 0.149404 14.751 0 15.001 0C15.251 0 15.479 0.149404 15.588 0.384632Z"
        fill="#F59E0B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.588 0.384632L57.8686 9.48172L67.4375 10.9409C67.6853 10.9794 67.8907 11.1612 67.9679 11.4103C68.0451 11.6594 67.9806 11.9327 67.8015 12.1157L60.8787 19.1952L62.5132 29.1937C62.5561 29.4515 62.4552 29.7125 62.2528 29.8665C62.0504 30.0206 61.7818 30.041 61.5603 29.9191L53.001 25.1995L44.4417 29.9205C44.2203 30.0428 43.9516 30.0228 43.7491 29.8687C43.5465 29.7147 43.4456 29.4536 43.4888 29.1957L45.1233 19.1952L38.1985 12.1157C38.0194 11.9327 37.9549 11.6594 38.0321 11.4103C38.1093 11.1612 38.3147 10.9794 38.5625 10.9409L48.1314 9.48172L52.414 0.384632C52.5229 0.149404 52.751 0 53.001 0C53.251 0 53.479 0.149404 53.588 0.384632Z"
        fill="#F59E0B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.588 0.384632L95.8686 9.48172L105.438 10.9409C105.685 10.9794 105.891 11.1612 105.968 11.4103C106.045 11.6594 105.981 11.9327 105.801 12.1157L98.8787 19.1952L100.513 29.1937C100.556 29.4515 100.455 29.7125 100.253 29.8665C100.05 30.0206 99.7818 30.041 99.5603 29.9191L91.001 25.1995L82.4417 29.9205C82.2203 30.0428 81.9516 30.0228 81.7491 29.8687C81.5465 29.7147 81.4456 29.4536 81.4888 29.1957L83.1233 19.1952L76.1985 12.1157C76.0194 11.9327 75.9549 11.6594 76.0321 11.4103C76.1093 11.1612 76.3147 10.9794 76.5625 10.9409L86.1314 9.48172L90.414 0.384632C90.5229 0.149404 90.751 0 91.001 0C91.251 0 91.479 0.149404 91.588 0.384632Z"
        fill="#F59E0B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129.588 0.384632L133.869 9.48172L143.438 10.9409C143.685 10.9794 143.891 11.1612 143.968 11.4103C144.045 11.6594 143.981 11.9327 143.801 12.1157L136.879 19.1952L138.513 29.1937C138.556 29.4515 138.455 29.7125 138.253 29.8665C138.05 30.0206 137.782 30.041 137.56 29.9191L129.001 25.1995L120.442 29.9205C120.22 30.0428 119.952 30.0228 119.749 29.8687C119.547 29.7147 119.446 29.4536 119.489 29.1957L121.123 19.1952L114.199 12.1157C114.019 11.9327 113.955 11.6594 114.032 11.4103C114.109 11.1612 114.315 10.9794 114.562 10.9409L124.131 9.48172L128.414 0.384632C128.523 0.149404 128.751 0 129.001 0C129.251 0 129.479 0.149404 129.588 0.384632Z"
        fill="#F59E0B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M167.588 0.384632L171.869 9.48172L181.438 10.9409C181.685 10.9794 181.891 11.1612 181.968 11.4103C182.045 11.6594 181.981 11.9327 181.801 12.1157L174.879 19.1952L176.513 29.1937C176.556 29.4515 176.455 29.7125 176.253 29.8665C176.05 30.0206 175.782 30.041 175.56 29.9191L167.001 25.1995L158.442 29.9205C158.22 30.0428 157.952 30.0228 157.749 29.8687C157.547 29.7147 157.446 29.4536 157.489 29.1957L159.123 19.1952L152.199 12.1157C152.019 11.9327 151.955 11.6594 152.032 11.4103C152.109 11.1612 152.315 10.9794 152.562 10.9409L162.131 9.48172L166.414 0.384632C166.523 0.149404 166.751 0 167.001 0C167.251 0 167.479 0.149404 167.588 0.384632Z"
        fill="#F59E0B"
      />
    </svg>
  );
};

export const InstagramIcon = () => {
  return (
    <svg
      className="h-[16px] w-[16px] md:h-[12.8px] md:w-[12.8px] 2xl:h-[24px] 2xl:w-[25px]"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5278 2.16867C15.7086 2.16867 16.1423 2.16867 17.4435 2.16867C18.6001 2.16867 19.1784 2.45783 19.6122 2.60241C20.1905 2.89157 20.6242 3.03615 21.058 3.46988C21.4917 3.90362 21.7808 4.33735 21.9254 4.91566C22.07 5.3494 22.2146 5.92771 22.3592 7.08434C22.3592 8.38554 22.3592 8.6747 22.3592 12C22.3592 15.3253 22.3592 15.6145 22.3592 16.9157C22.3592 18.0723 22.07 18.6506 21.9254 19.0843C21.6363 19.6627 21.4917 20.0964 21.058 20.5301C20.6242 20.9639 20.1905 21.253 19.6122 21.3976C19.1784 21.5422 18.6001 21.6867 17.4435 21.8313C16.1423 21.8313 15.8531 21.8313 12.5278 21.8313C9.20253 21.8313 8.91338 21.8313 7.61217 21.8313C6.45554 21.8313 5.87723 21.5422 5.4435 21.3976C4.86518 21.1084 4.43145 20.9639 3.99771 20.5301C3.56398 20.0964 3.27482 19.6627 3.13024 19.0843C2.98566 18.6506 2.84109 18.0723 2.69651 16.9157C2.69651 15.6145 2.69651 15.3253 2.69651 12C2.69651 8.6747 2.69651 8.38554 2.69651 7.08434C2.69651 5.92771 2.98566 5.3494 3.13024 4.91566C3.4194 4.33735 3.56398 3.90362 3.99771 3.46988C4.43145 3.03615 4.86518 2.74699 5.4435 2.60241C5.87723 2.45783 6.45554 2.31325 7.61217 2.16867C8.91338 2.16867 9.34711 2.16867 12.5278 2.16867ZM12.5278 0C9.20253 0 8.91338 0 7.61217 0C6.31097 0 5.4435 0.289157 4.7206 0.578314C3.99771 0.867471 3.27482 1.30121 2.55193 2.0241C1.82904 2.74699 1.53988 3.3253 1.10615 4.19277C0.81699 4.91566 0.67241 5.78313 0.527832 7.08434C0.527832 8.38554 0.527832 8.81928 0.527832 12C0.527832 15.3253 0.527832 15.6145 0.527832 16.9157C0.527832 18.2169 0.81699 19.0843 1.10615 19.8072C1.3953 20.5301 1.82904 21.253 2.55193 21.9759C3.27482 22.6988 3.85313 22.988 4.7206 23.4217C5.4435 23.7108 6.31097 23.8554 7.61217 24C8.91338 24 9.34711 24 12.5278 24C15.7086 24 16.1423 24 17.4435 24C18.7447 24 19.6122 23.7108 20.3351 23.4217C21.058 23.1325 21.7808 22.6988 22.5037 21.9759C23.2266 21.253 23.5158 20.6747 23.9495 19.8072C24.2387 19.0843 24.3833 18.2169 24.5278 16.9157C24.5278 15.6145 24.5278 15.1807 24.5278 12C24.5278 8.81928 24.5278 8.38554 24.5278 7.08434C24.5278 5.78313 24.2387 4.91566 23.9495 4.19277C23.6604 3.46988 23.2266 2.74699 22.5037 2.0241C21.7808 1.30121 21.2025 1.01205 20.3351 0.578314C19.6122 0.289157 18.7447 0.144578 17.4435 0C16.1423 0 15.8531 0 12.5278 0Z"
        fill="white"
      />
      <path
        d="M12.5278 5.78313C9.05795 5.78313 6.31097 8.53012 6.31097 12C6.31097 15.4699 9.05795 18.2169 12.5278 18.2169C15.9977 18.2169 18.7447 15.4699 18.7447 12C18.7447 8.53012 15.9977 5.78313 12.5278 5.78313ZM12.5278 16.0482C10.3592 16.0482 8.47964 14.3133 8.47964 12C8.47964 9.83133 10.2146 7.95181 12.5278 7.95181C14.6965 7.95181 16.576 9.68675 16.576 12C16.576 14.1687 14.6965 16.0482 12.5278 16.0482Z"
        fill="white"
      />
      <path
        d="M18.8893 7.08434C19.6878 7.08434 20.3351 6.43704 20.3351 5.63856C20.3351 4.84007 19.6878 4.19277 18.8893 4.19277C18.0908 4.19277 17.4435 4.84007 17.4435 5.63856C17.4435 6.43704 18.0908 7.08434 18.8893 7.08434Z"
        fill="white"
      />
    </svg>
  );
};

export const LinkedInIcon = () => {
  return (
    <svg
      className="h-[16px] w-[16px] md:h-[12.8px] md:w-[12.8px] 2xl:h-[20px] 2xl:w-[21px]"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.17648 19.7297H1.04134V6.71621H5.17648V19.7297ZM3.10891 4.89189C1.77107 4.89189 0.798096 3.91891 0.798096 2.58107C0.798096 1.24324 1.89269 0.270264 3.10891 0.270264C4.44675 0.270264 5.41972 1.24324 5.41972 2.58107C5.41972 3.91891 4.44675 4.89189 3.10891 4.89189ZM20.2576 19.7297H16.1224V12.6757C16.1224 10.6081 15.2711 9.99999 14.0548 9.99999C12.8386 9.99999 11.6224 10.973 11.6224 12.7973V19.7297H7.48728V6.71621H11.3792V8.54053C11.744 7.68918 13.2035 6.35134 15.2711 6.35134C17.5819 6.35134 20.0143 7.68918 20.0143 11.7027V19.7297H20.2576Z"
        fill="white"
      />
    </svg>
  );
};

export const FacebookIcon = () => {
  return (
    <svg
      className="h-[16px] w-[16px] md:h-[12.8px] md:w-[12.8px] 2xl:h-[24px] 2xl:w-[25px]"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.5278 12C24.5278 5.4 19.1278 0 12.5278 0C5.92783 0 0.527832 5.4 0.527832 12C0.527832 18 4.87783 22.95 10.5778 23.85V15.45H7.57783V12H10.5778V9.3C10.5778 6.3 12.3778 4.65 15.0778 4.65C16.4278 4.65 17.7778 4.95 17.7778 4.95V7.95H16.2778C14.7778 7.95 14.3278 8.85 14.3278 9.75V12H17.6278L17.0278 15.45H14.1778V24C20.1778 23.1 24.5278 18 24.5278 12Z"
        fill="white"
      />
    </svg>
  );
};

export const TwitterIcon = () => {
  return (
    <svg
      className="h-[16px] w-[16px] md:h-[12.8px] md:w-[12.8px] 2xl:h-[18px] 2xl:w-[21px]"
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_26_341)">
        <path
          d="M16.3061 0.100586H19.3254L12.729 7.64018L20.4894 17.8996H14.4128L9.65382 11.6772L4.20826 17.8996H1.18688L8.24247 9.8353L0.798096 0.100586H7.02849L11.3304 5.78797L16.3061 0.100586ZM15.2463 16.0922H16.9195L6.11947 1.81307H4.32418L15.2463 16.0922Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_26_341">
          <rect
            width="19.6913"
            height="17.799"
            fill="white"
            transform="translate(0.798096 0.100586)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const UploadSpeedIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.2"
        d="M51.3334 18.6662V20.9995C51.3334 27.5993 51.3329 30.898 49.2826 32.9483C47.2323 34.9985 43.9325 34.9985 37.3329 34.9985H18.6662C12.0665 34.9985 8.76666 34.9985 6.7164 32.9483C4.66669 30.8984 4.66669 27.601 4.66669 21.0046V20.9995V18.6662C4.66669 12.0666 4.66669 8.76678 6.71694 6.71648C8.76719 4.66619 12.067 4.66618 18.6667 4.66618H37.3334C43.933 4.66618 47.2327 4.66619 49.2831 6.71648C51.3334 8.76678 51.3334 12.0666 51.3334 18.6662Z"
        fill="#F24DBA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.9999 53.083C27.0334 53.083 26.2499 52.2995 26.2499 51.333V25.7303L22.3285 30.3052C21.6996 31.0391 20.5948 31.124 19.861 30.4949C19.1271 29.8661 19.0422 28.7613 19.6711 28.0274L26.671 19.8608C27.0035 19.473 27.4889 19.2497 27.9999 19.2497C28.5106 19.2497 28.996 19.473 29.3285 19.8608L36.3285 28.0274C36.9575 28.7613 36.8726 29.8661 36.1388 30.4949C35.4049 31.124 34.3001 31.0391 33.671 30.3052L29.7499 25.7303V51.333C29.7499 52.2995 28.9663 53.083 27.9999 53.083Z"
        fill="#F24DBA"
      />
    </svg>
  );
};

export const DownloadSpeedIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.2"
        d="M51.3334 37.3343V35.001C51.3334 28.4011 51.3329 25.1025 49.2826 23.0522C47.2323 21.002 43.9325 21.002 37.3329 21.002H18.6662C12.0665 21.002 8.76666 21.002 6.7164 23.0522C4.66669 25.102 4.66669 28.3995 4.66669 34.9958V35.001V37.3343C4.66669 43.9339 4.66669 47.2337 6.71694 49.284C8.76719 51.3343 12.067 51.3343 18.6667 51.3343H37.3334C43.933 51.3343 47.2327 51.3343 49.2831 49.284C51.3334 47.2337 51.3334 43.9339 51.3334 37.3343Z"
        fill="#22CBA7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 2.91699C27.0335 2.91699 26.25 3.7005 26.25 4.66699V30.2697L22.3287 25.6948C21.6997 24.9609 20.5949 24.876 19.8611 25.5051C19.1273 26.1339 19.0423 27.2387 19.6713 27.9726L26.6712 36.1392C27.0037 36.527 27.489 36.7503 28 36.7503C28.5108 36.7503 28.9961 36.527 29.3286 36.1392L36.3286 27.9726C36.9577 27.2387 36.8727 26.1339 36.1389 25.5051C35.4051 24.876 34.3002 24.9609 33.6712 25.6948L29.75 30.2697V4.66699C29.75 3.7005 28.9665 2.91699 28 2.91699Z"
        fill="#22CBA7"
      />
    </svg>
  );
};
